<div class="notification-item" (click)="markAsReadBySingleSelection(notification)">
  <div class="notification-item__title">
    <p class="typography__body-1--bold">{{ notification.subject }}</p>
  </div>
  <p [innerHTML]="notification.body" cmLinkHelper (downloadFile)="onDownloadFile($event)" class="notification-item__text"></p>
  <span class="typography__caption">{{ notification.createdDate | dateFormat }}</span>
  <span *ngIf="!notification.readDate" class="notification-item__indicator"></span>
</div>
